<ejs-dialog #functionDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-administration.overview.function-dialog.title' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-6">
        <ejs-listbox #functionListBox id="functionListBox" [dataSource]="functionList" [fields]="fieldList">
          <ng-template #itemTemplate let-data>
            {{ data.i18nLabel ?? 'i18n.domain.parker-administration.overview.function-dialog.functions.' + data.type |
            translate}}
          </ng-template>
        </ejs-listbox>
      </div>
      <div class="col-6">
        @if (isTheFunctionSelected(functionType.AddSubscriptionSet)) {
          <div>
            <app-edit-parker-edit-subscription-list-form id="addSetForm" [parkerSubscriptionForm]="subscriptionAssignmentForm"
              [clientId]="clientId" [allowDateSelectionInPast]="true" [useSubscriptionSets]="true">
            </app-edit-parker-edit-subscription-list-form>
          </div>
        }
        @if (isTheFunctionSelected(functionType.AddSubscriptions)) {
          <div>
            <app-edit-parker-edit-subscription-list-form [parkerSubscriptionForm]="subscriptionAssignmentForm"
              [clientId]="clientId" [allowDateSelectionInPast]="true">
            </app-edit-parker-edit-subscription-list-form>
          </div>
        }
        @if (isTheFunctionSelected(functionType.EndSubscriptions)) {
          <div>
            <app-parker-function-end-subscription-form [parkerSubscriptionForm]="subscriptionEndingForm"
              [clientId]="clientId">
            </app-parker-function-end-subscription-form>
          </div>
        }
        @if (isTheFunctionSelected(functionType.ReplaceSubscription)) {
          <div>
            <app-parker-function-replace-subscription-form [parkerSubscriptionForm]="subscriptionReplacementForm"
              [clientId]="clientId">
            </app-parker-function-replace-subscription-form>
          </div>
        }
        @if (isTheFunctionSelected(functionType.AdjustSubscriptions)) {
          <div>
            <app-edit-parker-edit-subscription-list-form [parkerSubscriptionForm]="subscriptionAssignmentForm"
              [clientId]="clientId" [allowDateSelectionInPast]="true">
            </app-edit-parker-edit-subscription-list-form>
          </div>
        }
        @if (isTheFunctionSelected(functionType.UnlinkParker)) {
          <div>
            {{'i18n.domain.parker-administration.overview.function-dialog.message-no-parameter-required' | translate}}
          </div>
        }
        @if (isTheFunctionSelected(functionType.DeactivateParker)) {
          <div>
            {{'i18n.domain.parker-administration.overview.function-dialog.message-no-parameter-required' | translate}}
          </div>
        }
        @if (isTheFunctionSelected(functionType.ResendLink)) {
          <div>
            {{'i18n.domain.parker-administration.overview.function-dialog.message-no-parameter-required' | translate}}
          </div>
        }
        @if (isTheFunctionSelected(functionType.ActivateParker)) {
          <div>
            {{'i18n.domain.parker-administration.overview.function-dialog.message-no-parameter-required' | translate}}
          </div>
        }
        @if (isTheFunctionSelected(functionType.RecalculateParkingSessions)) {
          <div>
            <app-parker-function-from-until-form [fromUntilForm]="fromUntilForm"></app-parker-function-from-until-form>
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeFunctionDialog()">
      {{'i18n.domain.parker-administration.overview.function-dialog.cancel-button' | translate}}
    </button>
    <button class="btn btn-primary" (click)="applyFunction()">
      {{'i18n.domain.parker-administration.overview.function-dialog.execute-function-button' | translate}}
    </button>
  </ng-template>
</ejs-dialog>

<ejs-dialog #functionStatusDialog [isModal]="true" [visible]="false" (open)="onStatusDialogOpened()">
  <ng-template #header>
    {{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.title-template' | translate:
    { function: 'i18n.domain.parker-administration.overview.function-dialog.functions.' + selectedFunction?.type | translate, parkerCount: numTotalRecordsToWorkOn} }}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col">
        <ejs-progressbar #functionStatus
                        id='functionStatus'
                        type='Linear'
                        height='60'
                        trackThickness="24"
                        progressThickness="24"
                        progressColor='#006633'
                        trackColor='#d1e7dd'
                        [width]="'100%'"
                        [value]='progressValue'
                        [animation]='animation'
                        [segmentCount]="segmentCount">
        </ejs-progressbar>
        <ejs-grid #statusGrid
                  width="100%"
                  rowHeight="38"
                  [dataSource]="executionStatus ?? []"
                  [hidden]="(executionStatus?.length ?? 0) <= 0">
          <e-columns>
            <e-column field="parker"
                      headerText=""
                      width="50"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                @if (data.status==='pending') {
                  <div class="spinner-border spinner text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                }
                @if (data.status==='success') {
                  <div class="icon icon-checkmark text-success" role="status">
                    <span class="visually-hidden">Success</span>
                  </div>
                }
                @if (data.status==='error') {
                  <div class="icon icon-close text-danger" role="status">
                    <span class="visually-hidden">Error</span>
                  </div>
                }
                @if (data.status==='warning') {
                  <div class="icon icon-warning text-warning" role="status">
                    <span class="visually-hidden">Warning</span>
                  </div>
                }
              </ng-template>
            </e-column>
            <e-column field="name"
                      width="200"
                      headerText="{{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.column-name' | translate}}"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{data.parkerInfo.firstName + ' ' + data.parkerInfo.lastName}}
              </ng-template>
            </e-column>
            <e-column field="status"
                      width="80"
                      headerText="{{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.column-status' | translate}}"
                      clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                {{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.status-' + data.status | translate}}
              </ng-template>
            </e-column>
            <e-column field="message"
                      headerText="{{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.column-message' | translate}}"
                      clipMode="EllipsisWithTooltip">
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div class="col-12">
        {{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.successful' | translate}}: {{actualExecutions - (executionStatus?.length ?? 0)}} - {{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.failed' | translate}}: {{executionStatus?.length ?? 0}}<br>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeStatusDialog()">
      {{'i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.close-button' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
